import React from "react";

export const Filter = ({ setFiltroElement }) => {
  return (
    <div className="buttons-filter-category">
      <>
        <select
          className="select"
          defaultValue=""
          onChange={(e) => {
            setFiltroElement(e.target.value);
          }}
        >
          <option className="option-type" disabled hidden value="">
            -- Type --
          </option>
          <option value={"normal"}>Normal</option>
          <option value={"fighting"}>Fighting</option>
          <option value={"flying"}>Flying</option>
          <option value={"poison"}>Poison</option>
          <option value={"ground"}>Ground</option>
          <option value={"flying"}>Flying</option>
          <option value={"bug"}>Bug</option>
          <option value={"ghost"}>Ghost</option>
          <option value={"dragon"}>Dragon</option>
          <option value={"dark"}>Dark</option>
          <option value={"steel"}>Steel</option>
        </select>
      </>
    </div>
  );
};

export default Filter;
